// extracted by mini-css-extract-plugin
module.exports = {"banner":"AreaPageHeaderBanner_banner__hE2vn","content":"AreaPageHeaderBanner_content__18fXM","icon":"AreaPageHeaderBanner_icon__G6kQn"};